import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      try {
        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
          navigate("/login", { replace: true });
          return;
        }
        const sessionId = match[1];
        // Clear hash
        window.history.replaceState(null, "", window.location.pathname);
        const { data } = await api.post("/auth/google-session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(data);
        toast.success(`¡Bienvenido/a, ${data.name}!`);
        const target = data.role === "catechist" ? "/dashboard/catequista" : "/dashboard/estudiante";
        navigate(target, { replace: true, state: { user: data } });
      } catch (e) {
        toast.error("No se pudo completar el inicio de sesión con Google");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <Loader2 className="w-12 h-12 animate-spin text-primary" />
      <p className="text-sm text-foreground/70">Confirmando tu sesión…</p>
    </div>
  );
}
